import { useEffect } from 'react';
import { useMutation } from '@tanstack/react-query';
import { api } from 'lib/httpClient';
import { useNotification } from 'hooks/ui/useNotification';

async function getInvestorCashBalanceById({
  investorId,
  firmId,
}: {
  investorId: string;
  firmId: string;
  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
}): Promise<{ data: number } | never> {
  const { data: response } = await api.post(
    `investor/cash-balance/${investorId}`,
    {
      firmId,
    },
  );
  return response;
}

export function useInvestorCashBalanceById() {
  const notification = useNotification();
  const mutation = useMutation({
    mutationFn: getInvestorCashBalanceById,
  });

  useEffect(() => {
    // @ts-expect-error
    if (mutation?.error?.response?.data?.responseMsg) {
      // @ts-expect-error
      notification.error(mutation.error.response.data.responseMsg);
    }
  }, [mutation.error]);

  return mutation;
}
